export const PATH_MEDICATIONS = 'medications';
